export default "__VITE_PUBLIC_ASSET__5e612de5__"